<rask-container-block>
    <div class="list-container">
        @if (tableColumnsJobbList) {
        <rask-table [data]="jobblist" [columns]="tableColumnsJobbList"></rask-table>
        }
    </div>
</rask-container-block>

<div>
    <span><b>Antal jobb som ligger på kö => {{ antalJobbsNotProcessed }}</b></span>
</div>

<rask-container-block>
    <div class="list-container">
        @if (tableColumns) {
        <rask-table [data]="details" [columns]="tableColumns"></rask-table>
        }
    </div>
</rask-container-block>
<div class="modal-footer">
    <rask-button color="secondary" (click)="dismiss()">Stäng</rask-button>
</div>